import React, { createContext, useContext, useState, useCallback } from "react";
import { getHorarioBySalon, uploadHorario } from "../services/salonesService";

const SalonesContext = createContext();

export const useSalones = () => useContext(SalonesContext);

export const SalonesProvider = ({ children }) => {
  const [horarios, setHorarios] = useState([]); // Horarios almacenados
  const [currentSalonId, setCurrentSalonId] = useState(null); // ID del salón cargado
  const [loading, setLoading] = useState(false);

  // Obtener horario optimizado
  const fetchHorario = useCallback(async (salonId) => {
    // Verificar si ya se cargó el horario para este salón
    if (currentSalonId === salonId && horarios.length > 0) {
      // console.log("El horario ya está cargado, no se realiza consulta");
      return;
    }

    setLoading(true);
    try {
      const data = await getHorarioBySalon(salonId); // Consulta al backend
      setHorarios(data || []); // Actualizar horarios
      setCurrentSalonId(salonId); // Guardar el salón cargado
    } catch (error) {
      
    } finally {
      setLoading(false);
    }
  }, [currentSalonId, horarios]);

  // Subir horario y actualizar
  const uploadHorarioData = async (data) => {
    setLoading(true);
    try {
      await uploadHorario(data);
      const salonId = data.get("salon_id"); // Obtener el salon_id del FormData
      await fetchHorario(salonId); // Refrescar datos después de la subida
    } catch (error) {
      
    } finally {
      setLoading(false);
    }
  };

  return (
    <SalonesContext.Provider
      value={{
        horarios,
        loading,
        fetchHorario,
        uploadHorarioData,
      }}
    >
      {children}
    </SalonesContext.Provider>
  );
};
